import { FunctionComponent } from "react";
import * as styles from "./styles.module.scss";
import clsx from "../../../modules/helpers/clsx";

export interface LoadingSpinnerProps {
  size: number;
  className?: string;
}

const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = (props) => {
  return (
    <div
      className={clsx({
        [styles.spinner]: true,
        [props.className ?? ""]: true,
      })}
      style={{ width: props.size, height: props.size }}
    />
  );
};

export default LoadingSpinner;
